import axios from 'axios'

const ACCESS_TOKEN_KEY = 'access_token'

let user = null

const baseURL = process.env.API_URL

export function login (username, password) {
  return axios.post(baseURL + '/login', { username, password })
    .then((response) => {
      const token = response.data.data.auth_token
      window.localStorage.setItem(ACCESS_TOKEN_KEY, token)
    })
}

export function logout () {
  window.localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export function loadUser () {
  const token = getAccessToken()
  if (!token) return null

  return axios.get(baseURL + '/me', {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
    .then((response) => {
      user = response.data.data
    })
}

export function getUser () {
  return user
}

export function isAuthenticated () {
  const token = getAccessToken()
  return !!token
}

export function getAccessToken () {
  return window.localStorage.getItem(ACCESS_TOKEN_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js